export const LaneTypes = [
    'manualpolygon',
    'bus',
    'left',
    'left', // intentional duplicate, cause thats how device reports numbers of active lanes
    'ego',
    'right',
    'rightheuristic',
    'right2',
    'absolute0',
    'absolute1',
    'absolute2',
    'absolute3',
    'busstop',
    'bike'
];
